export default __webpack_public_path__ + "static/media/dashboard.74519878.png";